import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import "./OrderStatusFlow.css";

const steps = [
  "Pending",
  "Confirmed",
  "Assigned",
  "PickedUp",
  "Processing",
  "ReadyForDelivery",
  "OutForDelivery",
  "Delivered"
];

export default function OrderStatusFlow() {
  const { orderId } = useParams();
  const API_URL = process.env.REACT_APP_API_PATH;

  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (orderId) {
      loadStatus();
    }
  }, [orderId]);

  const loadStatus = async () => {
    try {
      const res = await axios.get(`${API_URL}orders/${orderId}/status`
      );

      // If API returns:
      // { success:true, data:{ status:"Processing" } }
      if (res.data.data) {
        setStatus(res.data.data.status);
      }
      // If API returns:
      // { orderId:1, status:"Processing" }
      else {
        setStatus(res.data.status);
      }
    } catch (err) {
      console.error(err);
      setStatus("");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (status === "Cancelled") {
    return (
      <div className="cancel-box">
        <h3>❌ Order Cancelled</h3>
      </div>
    );
  }

  const activeIndex = steps.indexOf(status);

  return (
    <div className="status-container">
      {steps.map((step, index) => {
        let cls = "future";

        if (index < activeIndex) cls = "completed";
        else if (index === activeIndex) cls = "current";

        return (
          <div className="step-wrapper" key={step}>
            <div className={`circle ${cls}`}>
              {index < activeIndex ? "✓" : index + 1}
            </div>

            <div className={`label ${cls}`}>
              {step}
            </div>

            {index !== steps.length - 1 && (
              <div
                className={`line ${
                  index < activeIndex ? "completed" : ""
                }`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}